import React from 'react';
import Bans from '../bans';
import Study from './study';
import Types from './types';
import Search from './search';
import AddStudy from './add';
import Settings from '../settings';
import Dashboard from './dashboard';
import { Route } from 'react-router';

export default () => (
  <section>
    <Route exact path="/" component={Dashboard} />
    <Route path="/search" component={Search} />
    {process.env.REACT_APP_DISABLE_UPLOAD ? null : (
      <Route path="/add" component={AddStudy} />
    )}
    <Route path="/types/:type?" component={Types} />
    <Route path="/settings" component={Settings} />

    <Route path="/study/:id" component={Study} />

    <Route path="/bans" component={Bans} />
  </section>
);



// WEBPACK FOOTER //
// ./src/views/dashboard/index.js